import routersplit from './routersplits'
import routerSeparate from './routerSeparate'

const router = routersplit.concat(routerSeparate)

export default router



// WEBPACK FOOTER //
// ./src/router/routersplit/index.js